import { ImageFragment } from '@/lib/fragments'
import { graphql } from '@/lib/query'
const SectionHeroFragment = graphql(
  /* GraphQL */ `
    fragment SectionHeroFragment on SectionHeroRecord @_unmask {
      __typename
      variants
      _modelApiKey
      title
      text
      background
      image {
        ...ImageFragment
      }
    }
  `,
  [ImageFragment]
)

export default SectionHeroFragment
